/**
 * List of allowed domains for redirect URLs.
 * Only URLs from these domains (or their subdomains) are allowed for external redirects.
 * Relative paths (starting with /) are always allowed.
 *
 * @example
 * export const ALLOWED_REDIRECT_DOMAINS = ['*.extern.com'];
 */
export const ALLOWED_REDIRECT_DOMAINS: readonly string[] = ['*.extern.com', 'localhost'];
